import { ProductDoc } from '@gooduncles/gu-app-schema';
import { isArray } from 'lodash-es';

import { formatNumber } from 'src/utils/common';

import useProductById from 'src/hooks/swr/useProductById';

/**
 * value를 직접적으로 변경하는 {@link AgCellProduct}와 다르게 단순 표시만 진행한다.
 */
const AgCellProductInfo = (params: any, field: keyof ProductDoc, mapping?: Record<string, string>) => {
  const id = params.value;
  const { product } = useProductById(id);
  if (!product) return null;
  const value = product[field];
  if (value === null) return null;
  if (mapping) {
    return <span>{mapping[value as string]}</span>;
  }
  if (typeof value === 'boolean') return <span>{value ? '🟢' : '❌'}</span>;
  if (typeof value === 'string') return <span>{value}</span>;
  if (typeof value === 'number') return <span>{formatNumber(value)}</span>;
  if (isArray(value)) return <span>{value.join(', ')}</span>;
  if (typeof value === 'object') return <span>{JSON.stringify(value)}</span>;
  return null;
};

export default AgCellProductInfo;
